export function TickListIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' {...props}>
      <path
        d='M3.52855 15.2286L7.425 11.3321L7.76873 11.6758L3.19916 16.2671L0.711392 13.7793L1.04577 13.4529L2.82145 15.2286L3.175 15.5821L3.52855 15.2286ZM3.52855 7.60355L7.42082 3.71129L7.77203 4.07087L3.19862 8.64428L0.708496 6.17361L1.05 5.83211L2.82145 7.60355L3.175 7.95711L3.52855 7.60355ZM11 14.575V14.075H18.5V14.575H11ZM11 6.975V6.475H18.5V6.975H11Z'
        fill='currentColor'
        stroke='currentColor'
      />
    </svg>
  )
}
